import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import { Badge } from '@algoacademy/design-system/web/data-display/Badge';
import { H3 } from '@algoacademy/design-system/web/marketing/typography/Heading/H3';
import { P3 } from '@algoacademy/design-system/web/marketing/typography/Paragraph/P3';
import { BasicMentoringOptions } from '../../../Mentoring/BasicMentoring/Options';
export function BasicMentoringInfo(t0) {
  const $ = _c(7);
  const {
    activeSubscriptionTab
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <P3 className="text-slate-600">Wybrana subskrypcja</P3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <H3>Mentoring podstawowy</H3>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== activeSubscriptionTab) {
    t3 = <div className="flex flex-row flex-wrap items-center justify-between gap-2">{t2}<Badge className="w-fit bg-blue-100 px-2.5 font-semibold text-algoprimary">Subskrypcja co {activeSubscriptionTab}</Badge></div>;
    $[2] = activeSubscriptionTab;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BasicMentoringOptions />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <section className="flex-1 space-y-2">{t1}{t3}{t4}</section>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}